import { useState } from 'react';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
import { getImageUrl } from 'utils/tools';
import { ModalWrapper, PreviewWrapper } from './styles';
import { isImage } from 'utils/tools';
import { DynamicObjectType } from 'types/commons';

interface PreviewImageProps {
  src?: string;
  onPreview?: (item: DynamicObjectType) => void;
  className?: string;
  mt?: number;
  mr?: number;
}

const PreviewImage = ({
  src,
  onPreview,
  className,
  mt = 10,
  mr = 10,
}: PreviewImageProps) => {
  const [previewVisible, setPreviewVisible] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const handleCancel = () => {
    setPreviewVisible(null);
  };

  const onPreviewUI = (item) => {
    if (onPreview) {
      onPreview(item);
    } else {
      setPreviewVisible(true);
      setPreviewImage(item);
    }
  };
  return (
    <PreviewWrapper className={`mt-${mt} mr-${mr} ${className}`}>
      {isImage(src) ? (
        <img
          src={getImageUrl(src)}
          className={className || 'image'}
          alt={src}
        />
      ) : (
        <video
          src={src}
          className="flex items-center justify-center w-full h-full"
          controls
        >
          <track kind="captions" />
        </video>
      )}
      {src && (
        <div className="overlay">
          <EyeOutlined onClick={() => onPreviewUI(src)} />
        </div>
      )}
      <ModalWrapper open={previewVisible} footer={null} onCancel={handleCancel}>
        {isImage(previewImage) ? (
          <img
            alt="example"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src={getImageUrl(previewImage, 800)}
          />
        ) : (
          <video
            src={getImageUrl(previewImage)}
            controls
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        )}
      </ModalWrapper>
    </PreviewWrapper>
  );
};

PreviewImage.propTypes = {
  src: PropTypes.string,
  onPreview: PropTypes.func,
  className: PropTypes.string,
};

export default PreviewImage;
